import {
    HiChevronDoubleDown,
    HiChevronDoubleUp,
    HiMenuAlt4,
} from "react-icons/hi";


export const TasksStatuses = {
    NEW: {
        title: "New",
        color: "#FFEE93",
    },
    IN_PROGRESS: {
        title: "In Progress",
        color: "#8792E8",
    },
    REVIEW: {
        title: "Review",
        color: "#85FF8A",
    },
    CLOSED: {
        title: "Closed",
        color: "#EDECEC",
    },
    DELETED: {
        title: "Deleted",
        color: "#FFDADA",
    },
};

export const TasksPriorities = {
    low: {
        title: "Low",
        color: "#1CBB8C",
        icon: <HiChevronDoubleDown />,
    },
    medium: {
        title: "Medium",
        color: "#FCC34B",
        icon: <HiMenuAlt4 />,
    },
    high: {
        title: "High",
        color: "#DC3545",
        icon: <HiChevronDoubleUp />,
    },
};

export const ReportsStatuses = {
    0: {
        title: "New",
        color: "#FFEE93",
    },
    1: {
        title: "Open",
        color: "#85FF8A",
    },
    2: {
        title: "Assigned",
        color: "#F693FF",
    },
    3: {
        title: "In Progress",
        color: "#8792E8",
    },
    4: {
        title: "Closed",
        color: "#EDECEC",
    },
    5: {
        title: "Pending Deletion",
        color: "#FFDADA",
    },
    6: {
        title: "Deleted",
        color: "#FFDADA",
    },
};

export const Assets_STATUS_LIST = {
    NEW: {
        title: "New",
        backgroundColor: "#FFDAB9",
    },
    IN_PROGRESS: {
        title: "In Progress",
        backgroundColor: "#8792E8",
    },
    OPEN: {
        title: "Open",
        textColor: "#90F2F2",
    },
    APPROVED: {
        title: "Approved",
        backgroundColor: "#CBCBFA",
    },
    ASSIGNED: {
        title: "Assigned",
        backgroundColor: "#F693FF",
    },
    DELETED: {
        title: "Deleted",
        backgroundColor: "#FFDADA",
        opacity: 0.5,
    },
    PENDING_DELETION: {
        title: "Pending Deletion",
        backgroundColor: "#FFDADA",
    },
    REJECTED: {
        title: "Rejected",
        backgroundColor: "#FFDADA",
    },
};

export const TOM_STATUS_LIST = {
    IN_PROGRESS: {
        title: "In Progress",
        backgroundColor: "#0055F2",
    },
    COMPLETED: {
        title: "Completed",
        backgroundColor: "#8B8B8B",
    },
    APPROVED: {
        title: "Approved",
        backgroundColor: "#00B13E",
    },
}

export const General_STATUS_LIST = {
    NEW: {
        title: "New",
        backgroundColor: "#FFDAB9",
    },
    IN_PROGRESS: {
        title: "In Progress",
        backgroundColor: "#8792E8",
    },
    OPEN: {
        title: "Open",
        textColor: "#90F2F2",
    },
    APPROVED: {
        title: "Approved",
        backgroundColor: "#CBCBFA",
    },
    ASSIGNED: {
        title: "Assigned",
        backgroundColor: "#5DFFCF",
    },
    DELETED: {
        title: "Deleted",
        backgroundColor: "#FFDADA",
        opacity: 0.5,
    },
    PENDING_DELETION: {
        title: "Pending Deletion",
        backgroundColor: "#FFDADA",
    },
    COMPLETED: {
        title: "Completed",
        backgroundColor: "#2D9B4C",
    },
    REJECTED: {
        title: "Rejected",
        backgroundColor: "#FFDADA",
    },
};

export const REPORT_STATUS_NEW = 0;
export const REPORT_STATUS_OPEN = 1;
export const REPORT_STATUS_ASSIGNED = 2;
export const REPORT_STATUS_IN_PROGRESS = 3;
export const REPORT_STATUS_CLOSED = 4;
export const REPORT_STATUS_DELETED = 5;
export const REPORT_STATUS_PENDING_DELETION = 6;
export const REPORT_STATUS_REVIEW = 7;

export const GDPR_REPORT_STATUS_LIST = [
    {
        id: REPORT_STATUS_NEW,
        titleKey: "New",
        backgroundColor: "#FFDAB9",
    },
    {
        id: REPORT_STATUS_OPEN,
        titleKey: "Open",
        backgroundColor: "#90F2F2",
    },
    {
        id: REPORT_STATUS_ASSIGNED,
        titleKey: "Assigned",
        backgroundColor: "#F693FF",
    },
    {
        id: REPORT_STATUS_IN_PROGRESS,
        titleKey: "In Progress",
        backgroundColor: "#8792E8",
    },
    {
        id: REPORT_STATUS_CLOSED,
        titleKey: "Closed",
        backgroundColor: "#EDECEC",
    },
    {
        id: REPORT_STATUS_PENDING_DELETION,
        titleKey: "Pending Deletion",
        backgroundColor: "#FFDADA",
    },
    {
        id: REPORT_STATUS_DELETED,
        titleKey: "Deleted",
        backgroundColor: "#FFDADA",
        opacity: 0.5,
    },
    {
        id: REPORT_STATUS_REVIEW,
        titleKey: "Review",
        backgroundColor: "#D8BFD8",
    },
];

// Utility function to format the ID string
export const formatTaskAndRiskId = (
    type,
    Id,
    secondaryId,
    isMitigation,
    questionnaire,
    taskId
) => {
    const mainId = Id || secondaryId;
    if (questionnaire === "general") {
        if (isMitigation) {
            return `R${mainId}/T${taskId}`;
        } else if (type === "task") {
            return `T${taskId}`;
        } else if (type === "risk") {
            return `R${mainId}`;
        } else {
            return `R${mainId}`; // Default format for general
        }
    } else if (questionnaire === "software") {
        if (isMitigation) {
            return `A${mainId}/R${secondaryId}/T${taskId}`;
        } else if (type === "task") {
            return `A${mainId}/T${taskId}`;
        } else if (type === "risk") {
            return `A${mainId}/R${secondaryId}`;
        } else {
            return `R${mainId}`; // Default format for software
        }
    } else if (questionnaire === "other_asset") {
        if (isMitigation) {
            return `OA${mainId}/R${secondaryId}/T${taskId}`;
        } else if (type === "task") {
            return `OA${mainId}/T${taskId}`;
        } else if (type === "risk") {
            return `OA${mainId}/R${secondaryId}`;
        } else {
            return `R${mainId}`; // Default format for software
        }
    }
    else if (questionnaire === "tom") {
        return `T${taskId}`;
    } else if (questionnaire === "data_breach_incident") {
        if (isMitigation) {
            return `IN${mainId}/R${secondaryId}/T${taskId}`;
        } else if (type === "task") {
            return `IN${mainId}/T${taskId}`;
        } else if (type === "risk") {
            return `IN${mainId}/R${secondaryId}`;
        } else {
            return `R${mainId}`; // Default format for incident
        }
    } else if (questionnaire === "data_subject_request") {
        if (isMitigation) {
            return `DSR${mainId}/R${secondaryId}/T${taskId}`;
        } else if (type === "task") {
            return `DSR${mainId}/T${taskId}`;
        } else {
            return `R${mainId}`; // Default format for DSR
        }
    } else if (questionnaire === "control") {
        return `C${taskId}`;
    } else {
        return `R${mainId}`; // Fallback for unknown types
    }
};

/**************************************** NOTIFICATION SETTINGS ******************************************* */
export const NotificationSections = {
    risk: "Risk Assessment",
    task: "Task Management",
    dsr: "Data Subject Request",
    dbi: "Data Breach Incident",
    comment: "Comment",
};

export const NotificationActions = {
    comment: {
        comment_report:
            "I would like to receive an email when a user submits a comment",
        comment_mention:
            "I would like to receive an email when I am mentioned in a comment",
    },
    dbi: {
        new_dbi_reported:
            "I would like to receive an email when a user reports a new data breach incident",
        dbi_assign:
            "I would like to receive an email when I am assigned to a data breach incident",
        not_read_dbi:
            "I would like to receive an email when a data breach incident has not been opened after six days",
        not_closed_dbi:
            "I would like to receive an email when a data breach incident has not been closed within three months",
        status_dbi_report:
            "I would like to receive an email when the status of a data breach incident changes from closed to pending deletion",
    },
    dsr: {
        new_dsr_reported:
            "I would like to receive an email when a user submits a data subject request",
        dsr_assign:
            "I would like to receive an email when I am assigned to a data subject request",
        not_read_dsr:
            "I would like to receive an email when a new data subject request has not been opened after six days",
        not_closed_dsr:
            "I would like to receive an email when a data subject request has not been closed within three months",
        status_dsr_report:
            "I would like to receive an email when the status of a data subject request changes from closed to pending deletion",
    },
    risk: {
        risk_assign:
            "I would like to receive an email when a risk is assigned to me",
    },
    task: {
        task_comment:
            "I would like to receive an email when a user comments on a task",
        task_assign:
            "I would like to receive an email when a task is assigned to me",
        framework_controls_removed: "I would like to receive an email when controls are removed from my assigned tasks due to framework deactivation"
    },
};

/***************************************** CUSTOM FONTS ********************************* */
export const customFonts = [
    {
        style: "normal",
        family: "Inter",
        weight: 400,
    },
    {
        style: "normal",
        family: "Nunito",
        weight: 400,
    },
    {
        style: "normal",
        family: "Raleway",
        weight: 400,
    },
    {
        style: "normal",
        family: "Roboto Mono",
        weight: 400,
    },
    {
        style: "normal",
        family: "Noto Serif Toto",
        weight: 400,
    },
    {
        style: "normal",
        family: "Kumbh Sans",
        weight: 400,
    },
    {
        style: "normal",
        family: "Padyakke Expanded One",
        weight: 400,
    },
    {
        style: "normal",
        family: "Noto Sans Cherokee",
        weight: 400,
    },
];

export const AppDocumentsTypes = [
    {
        typeKey: "regular",
        title: "Other",
    },
    {
        typeKey: "user_policy",
        title: "User policy",
    },
    {
        typeKey: "privacy_policy",
        title: "Privacy policy",
    },
];

export const StaticOperatingSystems = [
    {
        id: "Windows 11",
        name: "Windows 11",
    },
    {
        id: "Windows 10",
        name: "Windows 10",
    },
    {
        id: "macOS",
        name: "macOS",
    },
    {
        id: "Ubuntu",
        name: "Ubuntu",
    },
    {
        id: "Debian",
        name: "Debian",
    },
    {
        id: "Android 14",
        name: "Android 14",
    },
    {
        id: "Android 13",
        name: "Android 13",
    },
    {
        id: "iOS 17",
        name: "iOS 17",
    },
    {
        id: "iOS 16",
        name: "iOS 16",
    },
    {
        id: "iPadOS",
        name: "iPadOS",
    },
];

export const ControlsFrameworks = [
    {
        key: "ISO27001",
        title: "ISO 27001:2022",
    },
    {
        key: "ISO42001",
        title: "ISO/IEC 42001",
    },
    {
        key: "TISAX",
        title: "TISAX (ISA v6)",
    },
    {
        key: "C5_2020",
        title: "C5:2020",
    },
    {
        key: "DORA",
        title: "DORA",
    },
    {
        key: "NIS2",
        title: "NIS2",
    },
];

/***************************************** SOFTWARE DATA TYPES ********************************* */

export const DATA_TYPE_OPTIONS = [
    { value: "Personal Data", label: "Personal Data" },
    {
        value: "Special Category Personal Data",
        label: "Special Category Personal Data",
    },
    { value: "Financial Data", label: "Financial Data" },
    { value: "Authentication Data", label: "Authentication Data" },
    { value: "Usage / Analytics Data", label: "Usage / Analytics Data" },
    { value: "Technical Logs", label: "Technical Logs" },
    { value: "System Configuration Data", label: "System Configuration Data" },
    { value: "Contractual Data", label: "Contractual Data" },
    { value: "Public Data", label: "Public Data" },
    { value: "Anonymized Data", label: "Anonymized Data" },
    { value: "Pseudonymized Data", label: "Pseudonymized Data" },
    { value: "Other", label: "Other" },
];

export const PERSONAL_DATA_SUB_CATEGORIES = [
    { value: "Personal Identifiers", label: "Personal Identifiers" },
    { value: "Contact Information", label: "Contact Information" },
    { value: "Employment Data", label: "Employment Data" },
    { value: "Customer Data", label: "Customer Data" },
    { value: "Supplier Data", label: "Supplier Data" },
    { value: "Location Data", label: "Location Data" },
    { value: "Device Data", label: "Device Data" },
];

export const SPECIAL_CATEGORY_PERSONAL_DATA_SUB_CATEGORIES = [
    { value: "Health Data", label: "Health Data" },
    { value: "Biometric Data", label: "Biometric Data" },
    { value: "Genetic Data", label: "Genetic Data" },
    { value: "Political Opinions", label: "Political Opinions" },
    { value: "Religious Beliefs", label: "Religious Beliefs" },
    { value: "Trade Union Membership", label: "Trade Union Membership" },
    { value: "Sexual Orientation", label: "Sexual Orientation" },
    { value: "Racial or Ethnic Origin", label: "Racial or Ethnic Origin" },
];

export const requiresSubcategory = (dataType) =>
    dataType === "Personal Data" || dataType === "Special Category Personal Data";

export const requiresTextSubcaregory = (dataType) => dataType === "Other";

/***************************************** CONTROL MAPPING TYPES ********************************* */

export const CONTROL_MAPPING_TYPE_COLORS = {
    direct: "#5CC850",
    partial: "#F5A14B",
    conceptual: "#FF4D4F",
    related: "#9C27B0",
};

export const CONTROL_MAPPING_TYPE_ORDER = [
    "direct",
    "partial",
    "conceptual",
    "related",
];

export const CONTROL_FRAMEWORK_MATRIX_HEAT_COLORS = {
    high: "#5CC850",
    mediumHigh: "#69C3C9",
    medium: "#F5A14B",
    low: "#FF4D4F",
};

export const RISK_LEVEL_DISPLAY = {
    high: { color: "#F5A14B", label: "High" },
    medium: { color: "#FCC34B", label: "Medium" },
    low: { color: "#1CBB8C", label: "Low" },
    critical: { color: "#DC3545", label: "Critical" },
};

export const AIRisks = {
    prohibited: {
        color: "#FEE2E2",
        title: "Prohibited Risk",
    },
    high_risk: {
        color: "#FEE2E2",
        title: "High Risk",
    },
    limited_risk: {
        color: "#FEE2E2",
        title: "Limited Risk",
    },
    minimal_risk: {
        color: "#DCFCE7",
        title: "Minimal Risk",
    },
    review_required: {
        color: "#FEF3C7",
        title: "Review Required",
        description:
            "Review is required because this AI system was not assigned a confirmed risk level. Do not treat it as minimal, limited, high, or prohibited risk until the AI Risk Assessment has been reviewed.",
    },
};

export const OTHER_ASSET_TYPES = {
    "document": {
        title: "Document"
    },
    "whiteboard": {
        title: "Whiteboard"
    },
    "binder": {
        title: "Binder"
    },
    "printed_email": {
        title: "Printed Email"
    },
    "other": {
        title: "Other"
    }
};

export const FRIA_STATUS = {
    NOT_AVAILABLE: {
        color: "secondary",
        label: "Not Available"
    },
    NOT_CREATED: {
        color: "warning",
        label: "Not Started"
    },
    IN_PROGRESS: {
        color: "info",
        label: "In Progress"
    },
    COMPLETED: {
        color: "success",
        label: "Completed"
    }
};

export const PROVIDER_CONFORMITY_STATUS = {
    not_required: {
        color: "secondary",
        label: "Not Required"
    },
    assessment_pending: {
        color: "warning",
        label: "Assessment Pending"
    },
    gaps_open: {
        color: "danger",
        label: "Gaps Open"
    },
    ready_for_conformity_assessment: {
        color: "info",
        label: "Ready for Conformity Assessment"
    },
    ready_for_ce_marking: {
        color: "success",
        label: "Ready for CE Marking"
    },
    placed_on_eu_market: {
        color: "success",
        label: "Placed on EU Market"
    }
};

export const CONFORMITY_OBLIGATION_STATUS = {
    gap: {
        color: "danger",
        label: "Gap",
        icon: "ri-error-warning-line"
    },
    met: {
        color: "success",
        label: "Met",
        icon: "ri-checkbox-circle-line"
    }
};

export const CONFORMITY_OBLIGATION_SOURCE_MAP = {
    ai_act_and_conformity_questionnaires: {
        label: "Derived from AI Risk & Conformity Assessments"
    }
};

export const COMPLIANCE_STATUS_MAP = {
    not_started: {
        label: "Not Started",
        color: "secondary",
        fontColor: "#FFFFFF",
        description:
            "No compliance assessments have been started for this software."
    },

    in_progress: {
        label: "In Progress",
        color: "info",
        fontColor: "#FFFFFF",
        description:
            "Required assessments are in progress and the compliance workflow is still being evaluated."
    },

    action_required: {
        label: "Action Required",
        color: "warning",
        fontColor: "#212529",
        description:
            "Outstanding findings, risks, or remediation activities require attention before compliance approval can be finalized."
    },

    approved: {
        label: "Approved",
        color: "success",
        fontColor: "#FFFFFF",
        description:
            "All required assessments have been completed and the software has been approved for use."
    },

    blocked: {
        label: "Blocked",
        color: "danger",
        fontColor: "#FFFFFF",
        description:
            "The software cannot proceed through the compliance process due to unresolved critical compliance issues."
    },

    closed: {
        label: "Closed",
        color: "dark",
        fontColor: "#FFFFFF",
        description:
            "The compliance process has been completed and no further compliance actions are required."
    }
};

export const COMPLIANCE_MODULES_LABELS_MAP = {
    ai_risk_assessment: {
        label: "AI Risk Assessment"
    },
    processing_activity: {
        label: "Processing Activity"
    },
    risk_assessment: {
        label: "Risk Assessment"
    },
    data_protection_impact_assessment: {
        label: "Data Protection Impact Assessment"
    },
    fria_assessment: {
        label: "FRIA Assessment"
    },
    conformity_assessment: {
        label: "Conformity Assessment"
    }
}

export const COMPLIANCE_MODULES_STATUS_MAP = {
    draft: {
        label: "Draft",
        color: "secondary"
    },
    in_progress: {
        label: "In Progress",
        color: "info"
    },
    submitted: {
        label: "Submitted",
        color: "primary"
    },
    approved: {
        label: "Approved",
        color: "success"
    },
    rejected: {
        label: "Rejected",
        color: "danger"
    }
}

export const COMPLIANCE_CASE_STATE_MAP = {
    draft: {
        label: "Draft",
        color: "secondary",
        description:
            "The compliance assessment has been created but not yet submitted for evaluation."
    },
    intake_complete: {
        label: "Initial Assessment Complete",
        color: "info",
        description:
            "Initial information has been collected and the compliance workflow is ready to proceed."
    },
    ropa_in_progress: {
        label: "Processing Activity In Progress",
        color: "warning",
        description:
            "The processing activity assessment is currently being completed."
    },
    triage: {
        label: "Under Assessment",
        color: "primary",
        description:
            "Assessment responses are being analyzed to determine required compliance reviews and next steps."
    },
    dpia_required: {
        label: "DPIA Required",
        color: "warning",
        description:
            "A Data Protection Impact Assessment is required before a compliance decision can be made."
    },
    dpia_in_progress: {
        label: "DPIA In Progress",
        color: "info",
        description:
            "The DPIA assessment is currently being completed."
    },
    ai_act_required: {
        label: "AI Act Assessment Required",
        color: "warning",
        description:
            "An AI Act assessment is required for this software."
    },
    ai_act_in_progress: {
        label: "AI Act Assessment In Progress",
        color: "info",
        description:
            "The AI Act assessment is currently being completed."
    },
    fria_required: {
        label: "FRIA Required",
        color: "warning",
        description:
            "A Fundamental Rights Impact Assessment is required before the review can continue."
    },
    fria_in_progress: {
        label: "FRIA In Progress",
        color: "info",
        description:
            "The FRIA assessment is currently being completed."
    },
    conformity_required: {
        label: "CE Conformity Required",
        color: "warning",
        description:
            "A Provider CE Conformity Assessment is required before the software can receive final AI approval."
    },
    conformity_in_progress: {
        label: "CE Conformity In Progress",
        color: "info",
        description:
            "The CE Conformity Assessment is currently being completed."
    },
    awaiting_decision: {
        label: "Awaiting Decision",
        color: "primary",
        description:
            "All required assessments have been completed and the system is preparing a compliance decision."
    },
    decided_conditional: {
        label: "Approved with Conditions",
        color: "warning",
        description:
            "The software may be used, but outstanding findings or remediation tasks must be completed."
    },
    reassessment_pending: {
        label: "Reassessment Pending",
        color: "info",
        description:
            "A follow-up review is scheduled to verify remediation actions and reassess compliance."
    },
    decided_go: {
        label: "Approved",
        color: "success",
        description:
            "All required assessments have been completed and no blocking compliance issues remain."
    },
    decided_no_go: {
        label: "Not Approved",
        color: "danger",
        description:
            "The software cannot be approved due to unresolved high-risk findings or compliance blockers."
    },
    closed: {
        label: "Closed",
        color: "secondary",
        description:
            "The compliance case has been completed and no further compliance actions are required."
    }
};

export const COMPLIANCE_CASE_DECISION_MAP = {
    go: {
        label: "Approved",
        color: "success",
        icon: "ri-checkbox-circle-line"
    },
    go_with_conditions: {
        label: "Approved with Conditions",
        color: "warning",
        icon: "ri-error-warning-line"
    },
    no_go: {
        label: "Not Approved",
        color: "danger",
        icon: "ri-close-circle-line"
    }
};

export const APPROVAL_STATUS_MAP = {
    approved: {
        label: "Approved",
        color: "success",
        icon: "ri-checkbox-circle-fill"
    },
    rejected: {
        label: "Rejected",
        color: "danger",
        icon: "ri-close-circle-fill"
    },
    pending: {
        label: "Pending",
        color: "warning",
        icon: "ri-time-line"
    },
    missing_assignee: {
        label: "Missing Assignee",
        color: "danger",
        icon: "ri-user-unfollow-line"
    }
};

export const AI_PROCESS_STATUS_MAP = {
    pending: {
        label: 'Pending',
        backgroundColor: '#FFF8E1',
        color: '#B26A00',
        tooltip: 'The software has been queued and is waiting for AI setup to begin.',
    },
    processing: {
        label: 'Processing',
        backgroundColor: '#E8F4FD',
        color: '#1565C0',
        tooltip: 'AI is currently configuring the software. It will be available once the setup is complete.',
    },
    completed: {
        label: 'Completed',
        backgroundColor: '#E8F5E9',
        color: '#2E7D32',
        tooltip: 'The AI setup has been completed successfully.',
    },
    failed: {
        label: 'Failed',
        backgroundColor: '#FDECEC',
        color: '#C62828',
        tooltip: 'The AI setup could not be completed. Please review the notification for more details.',
    }
};